import { useEffect, useState } from 'react'
import { companyApi } from 'src/api'
import { VersionsApps } from 'src/processes/version-getter/type'
import getConfig from 'next/config'

export function useVersionGetter() {
    const [versionsApps, setVersionsApps] = useState<VersionsApps>({
        webAPI: '',
        reactApp: '',
        webAPIOld: ''
    })

    useEffect(() => {
        const fetchingVersions = async () => {
            const webApi = await companyApi.getApiVersion()
            const webApiOld = await companyApi.getApi2Version()
            const { publicRuntimeConfig } = getConfig()
            setVersionsApps({
                webAPI: webApi?.isErrorResponse ? '' : webApi,
                webAPIOld: webApiOld?.isErrorResponse ? '' : webApiOld,
                reactApp: publicRuntimeConfig?.version
            })
        }
        fetchingVersions()
    }, [])

    return versionsApps
}
